import Classes from 'classnames';
import React from 'react';
import UserIcon from "core/gd-components/icons/user/user";

export default function SystemFieldUsersViewInImport(props) {



    // <img src="https://www.goodday.work/media/user/small/uUiAHy.jpeg" alt="" className="avatar-22 " />



    return <React.Fragment>

            {props.value && props.value.map(userId=>{

                const user = gd.session.users.get(userId);

                if (!user) {
                    return (
                        <div className="ui5-chip s22 red" key={userId}>
                            <div className="label">{userId}</div>
                        </div>
                    )
                }

                return (
                    <div className="ui5-chip s22 gray user" key={userId}>
                        <UserIcon size="22" userId={userId} className="user-icon"/>
                        <div className="label">{user.name}</div>
                    </div>
                )
            })}

    </React.Fragment>
}
